import { render, staticRenderFns } from "./wbjlDialog.vue?vue&type=template&id=1dcb195e&"
import script from "./wbjlDialog.vue?vue&type=script&lang=js&"
export * from "./wbjlDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports